import React from 'react'
//@ts-ignore
import s from './WrapModals.module.scss'

type WrapModalsT = {
    children: any
}
type ErrorMessage = {
    key: string;
    text: string;
}


export const ErrorMessages: ErrorMessage[] = [
    {
        key: "notZipCode",
        text: "We're sorry, there is no availability for zip code ", 
    },
    {
        key: "error_2",
        text: "Unfortunately we do not offer RTO for onsite builds",

    },
    {
        key: "error_3",
        text: "Buildings requiring permits must have wall height of at least 7 ft.",
    },
    {
        key: "error_4",
        text: "If permits are required please choose \"Signature\" or \"Limited\" series for foundation and framing.",
    },
];
export const WrapModals = ({ ...props }: WrapModalsT) => {
    const { children } = props; 
    return (
        <>
            <div className={s.wrap}>
                <div className={s.box}>
                    <div className={s.modal}>

                        {children}
                    </div>
                </div>
            </div>
        </>
    )
}
